import  { Fragment , useState} from 'react';
import { Button, Card, Col, Form, InputGroup } from 'react-bootstrap';
import {  Link } from 'react-router-dom';
import motimaticLogo from "src/assets/images/brand-logos/motimatic.png";
import { Paths } from 'src/paths';
import { useFormik } from "formik";
import * as Yup from "yup";
import MessageSent from './components/messageSent';
import { ChangePasswordService } from '@services/change-password/ChangePasswordService';

export default function RequestChange() { 
    const [currentForm] = useState({ email: ''});
    const [isSent, setIsSent] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const schemaValidation = Yup.object().shape({
        email: Yup.string().required("Email is required").email(),
     
      });


    const formikInstance = useFormik({
        initialValues: currentForm,
        enableReinitialize: true,
        validationSchema: schemaValidation,
        onSubmit: async (formState: any) => {
            /*
                The same silence as the reset page had (MPN-1778). This one asks for the
                link, and a request that fails here leaves somebody waiting for an email
                that is never coming, with nothing on screen to say so.

                The success path deliberately says nothing about whether the address exists
                -- the server answers 200 either way to avoid confirming who has an account
                -- so this only ever shows a genuine failure.
            */
            setError(null);
            try{
                const service = new ChangePasswordService();
                await service.requestChangePassword(formState.email);
                setIsSent(true);
            }catch(error: any){
                setError(error?.message || "Could not send that link. Please try again.");
            }
        }
      });

    if (isSent) 
        return <MessageSent/>;
    return(
        <Fragment>
            <div className="container-lg">
                <div className="row justify-content-center authentication authentication-basic align-items-center h-100">
                    <Col xxl={4} xl={5} lg={5} md={6} sm={8} className="col-12">
                        <div className="my-5 d-flex justify-content-center">
                            <div className="my-5 d-flex justify-content-center no-background w-50 mx-auto">
                                <img src={motimaticLogo} alt="logo" className="img-fluid" />
                            </div>
                        </div>
                        <Card className="custom-card">
                            <div className="card-body p-5">
                                <p className="h5 fw-semibold mb-2 text-center">Change Password</p>

                                {error && (
                                    <div className="alert alert-danger py-2 mb-3" role="alert">
                                        {error}
                                    </div>
                                )}

                                    <Form onSubmit={formikInstance.handleSubmit}>
                                        <div className="row gy-3">
                                            <Col xl={12}>
                                                <Form.Label htmlFor="email" className="form-label text-default">Email</Form.Label>
                                                <InputGroup>
                                                <Form.Control 
                                                    id="email"
                                                    name="email"
                                                    type="email"
                                                    className="form-control-lg"
                                                    placeholder="email"
                                                    value={formikInstance.values.email}
                                                    onChange={formikInstance.handleChange}
                                                    onBlur={formikInstance.handleBlur}
                                                    isInvalid={!!(formikInstance.touched.email && formikInstance.errors.email)}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {formikInstance.errors.email}
                                                </Form.Control.Feedback>
                                                </InputGroup>
                                            </Col>
                                            <Col xl={12} className=" d-grid mt-3">
                                                <Button type="submit" variant='primary' className="btn btn-lg">Change Password</Button>
                                            </Col>
                                        </div>
                                        <div className="text-center">
                                            <p className="fs-12 text-muted mt-3">Back to home ? <Link to={Paths.LOGIN} className="text-primary">Click Here</Link></p>
                                        </div>
                                    </Form>
                            </div>
                        </Card>
                    </Col>
                </div>
            </div>
        </Fragment>
    )
}